import { memo } from 'react'

import ExpandBtn from 'components/common/buttons/Expand'
import { useTranslation } from 'services/Translation'
import texts from './Texts'

const Header = ({ canExpand, onExpand, expanded }) => {
  const { t } = useTranslation(texts)

  return (
    <div className="px-8 ">
      <div className="h-12 w-full flex items-center justify-between relative z-30">
        {/* Full-width brand-blue header background */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '-4rem',
            height: '100%',
            width: 'calc(100% + 8rem)',
            background: 'linear-gradient(to bottom, rgba(46, 76, 230, 0.8) 0%, rgba(46, 76, 230, 0.8) 88%, #fcfcfc 100%)',
            zIndex: 0,
          }}
        />
        <div className="font-csc65 text-lg text-white relative" style={{ zIndex: 1 }}>
          {t('title')}
        </div>
        <div className="relative text-white" style={{ zIndex: 1 }}>
          <ExpandBtn canExpand={canExpand} onExpand={onExpand} expanded={expanded} reverseArrow arrowColor="#fff" />
        </div>
      </div>
    </div>
  )
}

Header.whyDidYouRender = true

export default memo(Header)
